import { TwinTranslationTF } from '../../hooks/useTwinTranslation';
import { TwinDictionary } from '../dictionary';
import { InputTableLayoutData } from '../../../baseComponents/TwinTable/InputTableLayout/types';
import { getConfigParam, getUserPermissions } from '../../reducers/getters';
import { SellDeliveryNoteTypeShippingInversed } from '@teinor/erp/types/company/order/sell/sellDeliveryNote';
import { checkIfOrderIsOkForSend, checkIfSelectedProductsAreOkForSend } from '../product/uniqueNumber';
import { permissionCheck } from '../../../baseComponents/PermissionChecker/function';
import { TwinParameters } from '@teinor/erp/types/company/config/parameter';

export const notHaveCountersWorkingCenter = (items: TwinDictionary) => {
    for (const key in items) {
        const item = items[key]
        items[key] = { ...item, is_blocked: !(item.WorkingCenterCounters?.length > 0) }
    }
    return items
}

const getSellShippingInfoMessage = (orderData: InputTableLayoutData, t: TwinTranslationTF) => {
    const sellShippingByDefault = getConfigParam('quoteShippingMandatory')
    if ((orderData.header.typeShipping === null || orderData.header.typeShipping === '') && (!sellShippingByDefault || sellShippingByDefault === 'on')) {
        return t('mustHaveShipping', 'Debes seleccionar tipo de envío para continuar')
    } else if (orderData.header.typeShipping && !orderData.header?.OrderShippingId && !orderData.header?.OrderShipping?.id && (!orderData.header.typeShipping || parseInt(orderData.header.typeShipping) === SellDeliveryNoteTypeShippingInversed['sendToCustomer'])) {
        return t('mustHaveShippingToContinue', 'Debes seleccionar un transporte para continuar')
    } else if (parseInt(orderData.header.typeShipping) === SellDeliveryNoteTypeShippingInversed['sendToCustomer'] && orderData?.header?.OrderShipping?.ShippingServices && orderData?.header?.OrderShipping?.ShippingServices.length === 0 && !orderData?.header?.OrderShipping?.ShippingService) {
        return t('mustHaveShippingServicesToContinue', 'Debe tener servicios de transportistas para continuar')
    }
    return null
}

const checkHaveProductsLength = (originalTableData: { [fieldName: string]: any; }[] | undefined, t: TwinTranslationTF) => {
    return originalTableData?.length ? null : t('mustAddProducts', 'Debes añadir productos para continuar')
}
const checkHaveProcessedDate = (orderData: InputTableLayoutData, t: TwinTranslationTF) => {
    return orderData?.header?.processed_date?.length ? null : t('mustAddProcessedDate', 'Debes añadir una fecha para continuar')
}
const checkHaveSerie = (orderData: InputTableLayoutData, t: TwinTranslationTF) => {
    return orderData?.header?.WorkingCenterCounterId ? null : t('mustAddWorkingCenterCounter', 'Debes añadir una serie para continuar')
}
const checkHaveUniqueNumber = (orderData: InputTableLayoutData, t: TwinTranslationTF) => {
    const checkIfDeliveryNoteReadyToFinish = !checkIfOrderIsOkForSend(orderData, t)
    if (checkIfDeliveryNoteReadyToFinish) {
        return t('addSameQuantitySerialLotNumberProducts', 'Debes añadir los números únicos correspondientes a la cantidad indicada del producto')
    }
    return null
}

const checkHavePaymentMethod = (orderData: InputTableLayoutData, t: TwinTranslationTF) => {
    const sellInvoicePaymentMethodMandatory = getConfigParam('sellInvoicePaymentMethodMandatory')
    if (sellInvoicePaymentMethodMandatory === 'off'){
        return null
    }
    return orderData.header?.PayMCopy?.PayMCopyDates?.length ? null : orderData.header?.PayMCopy ? t('mustFinishConfigPaymentMethod','Debes acabar de configurar el método de pago') :t('notHavePaymentMethod', 'No has configurado el método de pago')
}

export const checkSellFromOrderAllOk = (orderData: InputTableLayoutData | null, field: 'sellOrder' | 'sellDeliveryNote' | 'sellInvoice', t: TwinTranslationTF) => {
    if (orderData) {
        let result = checkHaveProductsLength(orderData.originalTableData, t)
        if (result) {
            return result
        }
        result = checkHaveSerie(orderData, t)
        if (result) {
            return result
        }
        result = getSellShippingInfoMessage(orderData, t)
        if (result) {
            return result
        }
        result = checkHaveProcessedDate(orderData, t)
        if (result) {
            return result
        }
        if (field === 'sellInvoice') {
            result = checkHavePaymentMethod(orderData, t)
            if (result) {
                return result
            }
        }
        if (field !== 'sellOrder') {
            result = checkHaveUniqueNumber(orderData, t)
            if (result) {
                return result
            }
        }
    }
}
export const checkIfCanCreateSell = (t: TwinTranslationTF, workingCenter?: TwinDictionary) => {
    let error: false | string = false;
    if (!workingCenter) {
        error = t('notCreateInNotWorkingCenter', 'No tienes centro de trabajo')
    } else if (!workingCenter.CurrencyId) {
        error = t('notCreateInNotWorkingCenterCurrencyId', 'Este centro de trabajo no tiene una moneda asignada')
    } else if (!workingCenter.address || !workingCenter.city || !workingCenter.postal_code || !workingCenter.state) {
        error = t('notCreateInNotWorkingCenterAddress', 'Este centro de trabajo no tiene una dirección fiscal completa')
    }
    return error
}

export const checkSellDeliveryNoteFromOrderAllOk = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    if (orderData) {
        let result = null
        const userPermission = getUserPermissions('sell.deliveryNote')
        if (!permissionCheck(userPermission, 'create')) {
            return t('notPermissionsCreateSellDeliveryNote', 'No tienes permisos para crear albaranes de venta')
        }
        const sellToFinished = getConfigParam('sellToDeliveryNoteFinished') as TwinParameters['sellToDeliveryNoteFinished']
        const nextStepFinished = sellToFinished === 'on' ? true : false
        if (nextStepFinished){
            result = getSellShippingInfoMessage(orderData, t)
            if (result) {
                return result
            }
            result = checkIfSelectedProductsAreOkForSend(orderData.selectedTableData?.length ? orderData.selectedTableData : orderData.tableData)
            if (!result) {
                return t('addSameQuantitySerialLotNumberProducts', 'Debes añadir los números únicos correspondientes a la cantidad indicada del producto')
            }
        }
    }
}

export const checkSellInvoiceFromOrderAllOk = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    if (orderData) {
        let result = null
        const userPermission = getUserPermissions('sell.invoice')
        if (!permissionCheck(userPermission, 'create')) {
            return t('notPermissionsCreateSellInvoice', 'No tienes permisos para crear facturas de venta')
        }
        const sellToFinished = getConfigParam('sellToInvoiceFinished') as TwinParameters['sellToDeliveryNoteFinished']
        const nextStepFinished = sellToFinished === 'on' ? true : false
        if (nextStepFinished){
            result = getSellShippingInfoMessage(orderData, t)
            if (result) {
                return result
            }
            result = checkIfSelectedProductsAreOkForSend(orderData.selectedTableData?.length ? orderData.selectedTableData : orderData.tableData)
            if (!result) {
                return t('addSameQuantitySerialLotNumberProducts', 'Debes añadir los números únicos correspondientes a la cantidad indicada del producto')
            }
        }
    }
}